import { render, staticRenderFns } from "./CollectAdvance.vue?vue&type=template&id=246db220&scoped=true"
import script from "./CollectAdvance.vue?vue&type=script&lang=js"
export * from "./CollectAdvance.vue?vue&type=script&lang=js"
import style0 from "./CollectAdvance.vue?vue&type=style&index=0&id=246db220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246db220",
  null
  
)

export default component.exports